import produce, { Draft } from "immer";

import { ACTIONS, ActionType } from "actions/appConfiguration/types";
import { AppConfigurationState } from "./types";

const initialAppConfiguration = {
    apiBaseUrl: "",
};

const appConfiguration = produce((state: Draft<AppConfigurationState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.SET_API_BASE_URL:
            state.apiBaseUrl = action.payload;
            break;
    }
}, initialAppConfiguration);

export default appConfiguration;
